import http from "../utils/http"

/**
 * 获取网站信息
 */
export function request(params) {
    return http({
        url: "/api/seo",
        data: params
    })
}
